module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery', {

		configure: function(options) {

			this.registerOptions('', {
				widgets: {
					emailForm: {
						widget: 'User_PasswordRecovery_Email',
						errorContainer: '.errors-block',
						autoRender: true,
						container: '#password-recovery-form',
						active: false,
						group: 'form'
					},
					confirmationForm: {
						widget: 'User_PasswordRecovery_Confirmation',
						errorContainer: '.errors-block',
						autoRender: true,
						container: '#password-recovery-form',
						active: false,
						group: 'form'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.callParent('running', arguments);

			this.start();
		},

		deactivate: function(argument) {
			this.callParent('deactivate', arguments);

			this._reactivationPool = [];
		},

		activate: function(argument) {
			this.callParent('activate', arguments);

			this.start();
		},

		start: function() {
			var hash = fox.Navigator.get(1);

			if (!hash) {
				this.switchEmbeddedWidget('emailForm');

				return;
			}

			this.switchEmbeddedWidget('confirmationForm');
		}


	}, 'Controller');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/user/passwordrecovery.js
// module id = 164
// module chunks = 4